import React, { useEffect, useRef, useState } from "react";
import "./EditarVagaoModal.css";

const sanitizeCodigoVagaoInput = (value, max = 40) =>
  String(value ?? "")
    .replace(/[\u0000-\u001F\u007F]/g, "")
    .replace(/[<>]/g, "")
    .replace(/\s+/g, "")
    .toUpperCase()
    .replace(/[^A-Z0-9]/g, "")
    .slice(0, max);

const sanitizeSerieVagaoInput = (value, max = 10) =>
  String(value ?? "")
    .replace(/[\u0000-\u001F\u007F]/g, "")
    .replace(/[<>]/g, "")
    .replace(/\s+/g, "")
    .toUpperCase()
    .replace(/[^A-Z0-9_-]/g, "")
    .slice(0, max);

const sanitizeCodigoVagaoSave = (value, max = 40) => sanitizeCodigoVagaoInput(value, max).trim();
const sanitizeSerieVagaoSave = (value, max = 10) => sanitizeSerieVagaoInput(value, max).trim();

export default function EditarVagaoModal({ open, onClose, onSalvar, serieInicial = "", codigoInicial = "" }) {
  const [serieVagao, setSerieVagao] = useState("");
  const [codigoVagao, setCodigoVagao] = useState("");
  const [busy, setBusy] = useState(false);
  const [err, setErr] = useState("");
  const serieVagaoRef = useRef(null);
  const codigoVagaoRef = useRef(null);

  useEffect(() => {
    if (!open) return;
    setSerieVagao(sanitizeSerieVagaoInput(serieInicial));
    setCodigoVagao(sanitizeCodigoVagaoInput(codigoInicial));
    setBusy(false);
    setErr("");

    const prev = document.body.style.overflow;
    document.body.style.overflow = "hidden";
    const t = setTimeout(() => serieVagaoRef.current?.focus(), 0);
    return () => {
      clearTimeout(t);
      document.body.style.overflow = prev;
    };
  }, [open, serieInicial, codigoInicial]);

  if (!open) return null;

  async function handleSalvar() {
    if (busy) return;
    setBusy(true);
    setErr("");
    try {
      const serie = sanitizeSerieVagaoSave(serieVagao);
      const codigo = sanitizeCodigoVagaoSave(codigoVagao);
      if (!serie) throw new Error("Informe a série do vagão.");
      if (!codigo) throw new Error("Informe o número do vagão.");
      await onSalvar?.({ serieVagao: serie, codigoVagao: codigo });
      onClose?.();
    } catch (e) {
      setErr(e?.response?.data?.error || e?.message || "Falha ao salvar alterações.");
    } finally {
      setBusy(false);
    }
  }

  return (
    <div className="ptemd-overlay" onClick={onClose}>
      <div className="ptemd-card" onClick={(e) => e.stopPropagation()} role="dialog" aria-modal="true" aria-label="Editar vagão">
        <div className="ptemd-head">
          <h3 className="ptemd-title">Editar Vagão</h3>
          <button className="ptemd-close" type="button" onClick={onClose} disabled={busy} aria-label="Fechar">
            x
          </button>
        </div>

        <div className="ptemd-body">
          <label className="ptemd-field">
            <span>Série</span>
            <input
              ref={serieVagaoRef}
              type="text"
              value={serieVagao}
              onChange={(event) => setSerieVagao(sanitizeSerieVagaoInput(event.target.value))}
              placeholder="Informe a série"
              autoComplete="off"
            />
          </label>
          <label className="ptemd-field">
            <span>Número</span>
            <input
              ref={codigoVagaoRef}
              type="text"
              value={codigoVagao}
              onChange={(event) => setCodigoVagao(sanitizeCodigoVagaoInput(event.target.value))}
              placeholder="Informe o número"
              autoComplete="off"
            />
          </label>
          {err ? <div className="ptemd-error">{err}</div> : null}
        </div>

        <div className="ptemd-foot">
          <button className="ptemd-btn ptemd-btn-ghost" type="button" onClick={onClose} disabled={busy}>
            Cancelar
          </button>
          <button className="ptemd-btn ptemd-btn-primary" type="button" onClick={handleSalvar} disabled={busy}>
            {busy ? "Salvando..." : "Salvar alterações"}
          </button>
        </div>
      </div>
    </div>
  );
}
